var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"contenu"}},[_c('Menu',{staticClass:"menuTopClient",attrs:{"id":"menuTop"}}),_c('div',{attrs:{"id":"centre"}},[_c(_vm.layout,{tag:"component"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }